import * as yup from 'yup';

export const validationSchema = yup.object({
    companyName: yup
        .string()
        .required("Required"),
    idNumber: yup
        .string()
        .required("Required"),
    website: yup
        .string()
        .required("Required"),
    email: yup
        .string()
        .email('Enter a valid email')
        .required("Required"),
    companyContact: yup
        .number()
        .typeError("Only number")
        .required('Required')
        .test(
            "is-positive",
            "Please enter a positive number",
            (value) => value >= 0 && 1 / value !== -Infinity),
    address1: yup
        .string()
        .required("Required"),
    // address2: yup
    //     .string()
    //     .required("Required"),
    countryId: yup
        .string()
        .required("Required"),
    stateId: yup
        .string()
        .required("Required"),
    areaId: yup
        .string()
        .required("Required"),
    postcode: yup
        .string()
        .required("Required"),
})

export const initialValues = {
    companyName: "",
    idNumber: "",
    website: "",
    email: "",
    companyContact: "",
    address1: "",
    address2: "",
    countryId: "",
    stateId: "",
    areaId: "",
    postcode: "",
    status: true,
}